(function () {
  'use strict';

  angular
    .module('crewFlyingExperiance')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('crewFlyingExperiance', {
        url: '/crew-flying-experiance',
        views: {
          'crewFlyingExperianceView': {
            templateUrl: 'crew-flying-experiance/views/crew-flying-experiance.tpl.html',
            controller: 'CrewFlyingExperianceCtrl',
            controllerAs: 'crewFlyingExperiance'
          }
        }
      });
  }
}());
